import { siteContent } from '@/config'
import type { NavGroup, NavNode } from '@/config'

export const utilityNav = siteContent.navigation.utility
export const ctaLinks = siteContent.navigation.actions
export const navGroups = siteContent.navigation.groups
export const shellHighlights = siteContent.pages.home.highlights

export function isNavGroup(node: NavNode): node is NavGroup {
  return 'items' in node
}
